import type { BaseOptionType } from 'antd/es/select';
import { useMemo, useState } from 'react';

import { getTimezoneList } from '@/utils/util';

const useTimezoneSelect = (
  initialValue?: string,
): [BaseOptionType[], string, (value: string) => void] => {
  const timezoneList = getTimezoneList();

  const options: BaseOptionType[] = useMemo(() => {
    return timezoneList.map((t) => {
      return {
        value: t.tzCode,
        label: t.name,
      };
    });
  }, [timezoneList]);

  const [selected, setSelected] = useState(initialValue || options[0].value);

  return [options, selected, setSelected];
};

export default useTimezoneSelect;
